const environment = {
  SHOW_SURVEY: true,
  SHOW_ACCOUNT_LINK_API: true,
  SHOW_WEBHOOKS: process.env.NEXT_PUBLIC_SHOW_WEBHOOKS === 'true',
};

export default environment;
